<div class="modal fade show in" id="claims-modal" tabindex="-1" aria-labelledby="claims-modalLabel" aria-hidden="true"
    [ngStyle]="{'display': 'block'}">
    <div class="modal-dialog modal-lg">
        @if (showLoader()) {
            <app-loader></app-loader>
        }
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title mb-0">Service Orders list for Claims</h3>
            </div>
            <div class="modal-body claim-service-orders-body">
                <inavista-grid #claimServiceOrdersGrid
                    [config]="gridConfig"
                    [actionIcons]="actionIcons"
                    (actionIconClick)="onActionIconClick($event)"
                    (hyperlinkClick)="onHyperlinkClick($event)"
                    (exportRequested)="onExportRequested($event)" />
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

@if (serviceOrderPopup(); as so) {
    <app-isc-popup
        [id]="so.id"
        [data]="so.data"
        (onClose)="serviceOrderPopup.set(null)"
    ></app-isc-popup>
}
